import { LayoutDashboard, Users, Award, FileUp, Receipt, Wallet, History, MessagesSquare, Calendar, Megaphone, Bell, Settings } from 'lucide-react';
import type { NavItem } from '@/components/layout/RoleLayout';

/** Parent menu: my children → paying → hearing from the school → me. */
export const nav: NavItem[] = [
  { to: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, group: 'Overview' },

  { to: 'children', label: 'My children', icon: Users, group: 'My children' },
  { to: 'results', label: 'Results & report sheets', icon: Award, group: 'My children' },
  { to: 'document-requests', label: 'Documents the school needs', icon: FileUp, group: 'My children' },

  { to: 'fees', label: 'Pay school fees', icon: Receipt, group: 'Payments' },
  { to: 'wallet', label: 'Wallet', icon: Wallet, group: 'Payments' },
  { to: 'payment-history', label: 'Payments & receipts', icon: History, group: 'Payments' },

  { to: 'messages', label: 'Message a teacher', icon: MessagesSquare, group: 'School' },
  { to: 'notices', label: 'Notices', icon: Megaphone, group: 'School' },
  { to: 'calendar', label: 'Calendar & events', icon: Calendar, group: 'School' },

  { to: 'notifications', label: 'Notifications', icon: Bell, group: 'Me' },
  { to: 'settings', label: 'Account & security', icon: Settings, group: 'Me' },
];
